import EindbeoordelingKeuringStooktoestelClass from '@/domain/interface/activiteit/eindbeoordeling/EindbeoordelingKeuringStooktoestelClass';
import { EindbeoordelingOnderhoudStooktoestelClass } from '@/domain/interface/activiteit/eindbeoordeling/EindbeoordelingOnderhoudStooktoestelClass';
import { ToestelClass } from '@/domain/interface/activiteit/kenmerk/ToestelClass';
import { ActiviteitDetailClass } from '@/domain/interface/activiteit/ActiviteitDetailClass';
import { LinkInterface } from '@/domain/interface/LinkInterface';

export class BevestigingActiviteitClass {
  eindbeoordelingKeuring?: EindbeoordelingKeuringStooktoestelClass;
  eindbeoordelingOnderhoud?: EindbeoordelingOnderhoudStooktoestelClass;
  toestel: ToestelClass;
  meldingDetail: ActiviteitDetailClass;
  redenWeigering?: string;
  ownerIsErkendeTechnicus?: boolean;
  erkendeTechnicusVerplichtAanwezig?: boolean;
  verplichtVoorNietOpgevenErkendeTechnicus?: boolean;
  links?: LinkInterface;
  opmerkingen?: string[];

  constructor(bevestigingActiviteit?: BevestigingActiviteitClass) {
    this.eindbeoordelingKeuring = bevestigingActiviteit?.eindbeoordelingKeuring;
    this.eindbeoordelingOnderhoud = bevestigingActiviteit?.eindbeoordelingOnderhoud;
    this.toestel = bevestigingActiviteit?.toestel || new ToestelClass();
    this.meldingDetail = bevestigingActiviteit?.meldingDetail ? new ActiviteitDetailClass(bevestigingActiviteit.meldingDetail) : new ActiviteitDetailClass();
    this.redenWeigering = bevestigingActiviteit?.redenWeigering;
    this.ownerIsErkendeTechnicus = bevestigingActiviteit?.ownerIsErkendeTechnicus;
    this.erkendeTechnicusVerplichtAanwezig = bevestigingActiviteit?.erkendeTechnicusVerplichtAanwezig;
    this.verplichtVoorNietOpgevenErkendeTechnicus = bevestigingActiviteit?.verplichtVoorNietOpgevenErkendeTechnicus;
    this.links = bevestigingActiviteit?.links;
    this.opmerkingen = bevestigingActiviteit?.opmerkingen;
  }
}
